<template>
  <!-- <v-chart class="w-full h-72 chart" :option="option" autoresize ref="currentMasteryChart" /> -->
  <div ref="currentMasteryChart" class="w-full h-72 chart"></div>
</template>

<script>
import { ref, onMounted, watch } from "vue";
// import VChart from "vue-echarts";
import * as echarts from "echarts";
import i18n from "@/plugins/i18n";

export default {
  name: "TaskCompletionChart",
  props: {
    data: {
      type: Array,
      required: true,
    },
    months: {
      type: Array,
      required: true,
    },
  },
  setup(props, { emit }) {
    const currentMasteryChart = ref(null);

    const initChart = () => {
      if (!currentMasteryChart.value) {
        return;
      }
      
      const chart = echarts.init(currentMasteryChart.value);

      const maxLearners = Math.max(
        ...props.data.map((item) => item.totalLearners)
      );

      const option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        xAxis: {
          type: "category",
          data: (props.data || []).map((item) => {
            return item.week;
          }),
          axisLine: {
            lineStyle: {
              color: "#E4E7EB",
            },
          },
          axisLabel: {
            color: "#475467",
          },
          // axisLabel: {
          //   color: "#475467",
          //   interval: 0,
          //   formatter: function (value, index) {
          //     const day = parseInt(value, 10);
          //     let month = "";

          //     if (index === 0) {
          //       month = props.months[0];
          //     } else if (index === props.data.length - 1) {
          //       month = props.months[1];
          //     }

          //     if (index === 0 || day === 1 || index === props.data.length - 1) {
          //       return `{day|${day}}\n{month|${month}}`;
          //     }

          //     return `{day|${day}}`.toString();
          //   },
          //   rich: {
          //     day: {
          //       color: "#58595B",
          //       fontSize: 10,
          //       lineHeight: 18,
          //     },
          //     month: {
          //       color: "#58595B",
          //       fontSize: 14,
          //       fontWeight: "medium",
          //       lineHeight: 18,
          //     },
          //   },
          // },
          // name: "Months",
          // nameLocation: "middle",
          nameTextStyle: {
            fontWeight: "bold",
            fontSize: 12,
            padding: 20,
            color: "#475467",
          },
        },
        yAxis: {
          type: "value",
          max: maxLearners,
          axisLine: {
            lineStyle: {
              color: "#475467",
            },
          },
          axisLabel: {
            color: "#475467",
          },
          splitLine: {
            lineStyle: {
              color: "#F1F3F5",
            },
          },
          name: i18n.global.t("overview_page.students"),
          nameLocation: "middle",
          nameTextStyle: {
            fontWeight: "bold",
            fontSize: 12,
            padding: 15,
            color: "#475467",
          },
        },
        grid: {
          left: "4%",
          right: "4%",
          bottom: "12%",
          top: "5%",
          containLabel: true,
        },
        series: [
          {
            name: i18n.global.t("overview_page.tasks_completed"),
            type: "bar",
            stack: "tasks",
            data: (props.data || []).map((item) => item.students || 0),
            itemStyle: {
              borderRadius: [10, 10, 0, 0],
              color: function (params) {
                const colors = props.data.map((item) => item.color);
                return colors[params.dataIndex % colors.length];
              },
            },
            barWidth: "40%",
          },
        ],
      };

      chart.setOption(option);

      chart.on('click', (params) => {
        emit('taskCompletionLearners', params);
      });
    };

    onMounted(() => {
      if (props.data) {
        initChart();
      }
    });

    watch(
      () => props.data,
      () => {
        initChart();
      }
    );

    return {
      currentMasteryChart,
    };
  },
};
</script>
